module.exports = __webpack_public_path__ + "static/media/subtraction.4b52dc70.svg";